import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoaderSpinnerService } from './loader-spinner.service';

export const loaderSpinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderSpinnerService = inject(LoaderSpinnerService);
  
  loaderSpinnerService.show();
  
  return next(req).pipe(
    finalize(() => {
      loaderSpinnerService.hide();
    })
  );
};